import { render, staticRenderFns } from "./orderDenyNCRDialog.vue?vue&type=template&id=6807a32c&"
import script from "./orderDenyNCRDialog.vue?vue&type=script&lang=js&"
export * from "./orderDenyNCRDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports